import React from 'react';
import './css/Politica.css';
import './css/TextPage.css';

const LGPD: React.FC = () => {
  return (
    <div className="politica-container politica-lgpd text-page">
      <span className="politica-eyebrow">Proteção de Dados</span>
      <h1>LGPD</h1>

      <section className="politica-card politica-highlight" aria-label="Resumo sobre tratamento de dados">
        <p>
          O Senac AM não realiza a coleta e o tratamento de dados pessoais dos visitantes deste portal.
          Dados referentes à origem do acesso, tempo de permanência e conteúdo pesquisado tornam-se
          anônimos na plataforma de monitoramento Google Analytics e são utilizados com o intuito de
          melhorar a experiência dos usuários no portal.
        </p>
      </section>

      <section className="politica-card">
        <h2>Navegação e cookies</h2>
        <p>
          Durante a navegação, não serão armazenados dados pessoais em cookies ou por outra tecnologia.
          Para saber mais informações,{' '}
          <a
            href="https://support.google.com/analytics/answer/6004245"
            target="_blank"
            rel="noopener noreferrer"
          >
            clique aqui
          </a>
          .
        </p>
      </section>

      <section className="politica-card">
        <h2>Atendimento de demandas</h2>
        <p>
          A coleta ou o tratamento de dados pessoais serão realizados pelo Senac AM quando forem
          necessários para atendimento de demandas dos usuários. Nesses casos, o visitante será
          informado sobre o tratamento antes de fornecer qualquer dado.
        </p>
      </section>

      <section className="politica-card">
        <h2>Contato sobre dados pessoais</h2>
        <p>
          Em caso de requisições ou dúvidas sobre informações pessoais tratadas pelo Departamento
          Regional do Senac Amazonas, entre em contato com Maria Socorro de Sousa Pereira, por meio
          do endereço de email:{' '}
          <a href="mailto:dadospessoais@am.senac.br">dadospessoais@am.senac.br</a>.
        </p>
      </section>

      <section className="politica-card">
        <h2>Lei Geral de Proteção de Dados Pessoais</h2>
        <p>
          Essas medidas seguem as exigências da Lei Geral de Proteção de Dados Pessoais. Para mais
          informações sobre a LGPD,{' '}
          <a
            href="https://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm"
            target="_blank"
            rel="noopener noreferrer"
          >
            clique aqui
          </a>
          .
        </p>
      </section>
    </div>
  );
};

export default LGPD;
